package com.kinoshazam.screens.rootFlow

import androidx.compose.runtime.Composable
import presentation.screens.RootMVIAction
import presentation.screens.RootState

@Composable
actual fun UpdateScreen(
    state: RootState,
    cancel: () -> Unit,
    onAction: (RootMVIAction) -> Unit,
) {
    StoreUpdateNotice(cancel = cancel)
}
